import State from '../core/State';
import initialState from '../initialState';
import { DateTime } from 'luxon';
import produce, { Draft } from 'immer';

export const setFromPeriod = (date: DateTime) =>
  produce((draft: Draft<State>) => {
    draft.globalChartSetting.period.from = date;
  });

export const setToPeriod = (date: DateTime) =>
  produce((draft: Draft<State>) => {
    draft.globalChartSetting.period.to = date;
  });

export const setFromSubPeriod = (date: DateTime) =>
  produce((draft: Draft<State>) => {
    draft.globalChartSetting.subPeriod.from = date;
  });

export const setToSubPeriod = (date: DateTime) =>
  produce((draft: Draft<State>) => {
    draft.globalChartSetting.subPeriod.to = date;
  });

export const setIncludePreviousFlag = (flag: boolean) =>
  produce((draft: Draft<State>) => {
    draft.globalChartSetting.isIncludePrevious = flag;
  });

export const dispose = () =>
  produce((draft: Draft<State>) => {
    draft.globalChartSetting = initialState.globalChartSetting;
  });
